export default {
    api: {
        agent: 'https://agent.pms.guandb.cn',
        image: 'https://image.pms.guandb.cn',
        material: 'https://material.pms.guandb.cn',
    },
    messageBrokerUrl: 'wss://broker.mqtt.guandb.cn/mqtt',
    openObserveOption: {
        clientToken: 'rumWSAU7bVU9mT5EflD',
        applicationId: 'activity',
        site: 'analyze.guandb.cn',
        service: 'activity',
        organizationIdentifier: 'guandb',
        insecureHTTP: false,
        apiVersion: 'v1',
    },
    qqMapKey: 'WJPBZ-NLVY3-WJ337-O4BZU-55RD5-CIBWD'
}